<template>
  <div class="c-carousel">
    <div class="carousel-childs">
      <div class="items" v-for="o in list" :key="o.id">
        <a @click="toNewPager(o.adUrl)">
          <img v-bind:src="o.adPic" alt="" />
        </a>
      </div>
    </div>
    <ol class="carousel-active">
      <li
        v-for="(o, i) in list"
        :key="o.id"
        :class="{ active: activeIndex === i }"
        @click="active(i)"
      ></li>
    </ol>
    <div class="carousel-prev" @click="prev()">
      <span class="icon icontemp left"></span>
    </div>
    <div class="carousel-next" @click="next()">
      <span class="icon icontemp right"></span>
    </div>
  </div>
</template>

<script>
import { Carousel } from "@/common/carousel";
import { $subscriber, cr, interact } from "fire-wind-water";
export default {
  name: "Carousel",
  data() {
    return {
      activeIndex: 0,
      list: []
    };
  },
  methods: {
    active(i) {
      this.lb.active(i);
    },
    prev() {
      this.lb.prev();
    },
    next() {
      this.lb.next();
    },
    toNewPager(href) {
      if (href && href != "") {
        window.open(href);
      }
      return;
    }
  },
  created() {
    this.lb = new Carousel({
      change: i => {
        this.activeIndex = i;
      }
    });
    $subscriber.subscribe("webinarInfo", data => {
      let arr = [];
      cr.each(data.adList, item => {
        if (
          (interact.isMobile && item.adDevice == "wap") ||
          (!interact.isMobile && item.adDevice != "wap")
        ) {
          if (item.adType == "1") {
            arr.push(item);
          }
        }
      });
      this.list = arr;
    });
  },
  mounted() {
    this.lb.initElem(document.querySelector(".c-carousel .carousel-childs"));
  },
  updated() {
    this.lb.initChild();
  }
};
</script>

<style scoped></style>
